var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.774 1.392l-1.887-.66-.446 1.273H6.5a3 3 0 00-3 3v14a3 3 0 003 3h2.94l-.214.614 1.857.65 7.53-21.424h.002l.16-.453zm1.352 2.161L18.5 8.105v8.487l-3.383 3.413h-.867l-.714 2h2.415l.293-.296 3.966-4.002.29-.292V5.005c0-.526-.136-1.022-.374-1.452zM6.5 4.005h9.24l-1.75 5H8.5v1h5.14l-.524 1.5H8.5v1h4.266l-.525 1.5H8.5v1h3.39l-1.75 5H6.5a1 1 0 01-1-1v-14a1 1 0 011-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoid);
export default __webpack_public_path__ + "static/media/void.c3b82241.svg";
export { ForwardRef as ReactComponent };